<template>
  <div class="header_wrapper">
    <header>
      <a href="https://go-sha.ru/" class="logo">GO-SHA.RU</a>
      <p class="ek">Котов Егор</p>
      <div class="lang_button_wrapper">
        <a @click.prevent="changeLang" class="lang_button" :class="{active: lang === 'en'}">EN</a>
        <a @click.prevent="changeLang" class="lang_button" :class="{active: lang === 'ru'}">RU</a>
      </div>
      <div class="social_wrapper">
        <a href="#" class="ico google"></a>
        <a href="http://vk.com/ekotov77" class="ico vk"></a>
        <a href="mailto:mail@go-sha.ru" class="ico mail"></a>
        <a href="#" class="ico facebook"></a>
      </div>
      <Menu :lang="lang" :is-header="true" />
    </header>
  </div>
</template>

<script>
import Menu from "./Menu";
export default {
  name: 'Header',
  components: {Menu},
  props: {
    lang: String
  },
  data() {
    return {
      activeClass: 'vis ',
      menu: {
        'ru': [
                'Главная',
                'Мои работы',
                'О себе',
                'контакты'
        ],
        'en': [
          'Home',
          'About',
          'Portfolio',
          'Contacts'
        ]
      }
    }
  },
  computed: {
    currentPage() {
      return this.$route.path
    }
  },
  methods: {
    changeLang() {
      this.$emit('change-lang')
    }
  }
}
</script>

<style>
  header .menu_wrapper{
    padding-top: 142px;
    padding-left: 250px;

  }
  header .menu{
    background: url("../assets/img/menu_bg.png") no-repeat;
    text-align: center;
    position: relative;
  }
  header .menu a{
    display: block;
    position: relative;
    float: left;
    height: 33px;
    width: 110px;
    line-height: 33px;
    color: #839496;
    text-transform: uppercase;
    font-family: Arial, sans-serif;
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
  }
  header .m_arrow{
    display: none;
    position: absolute;
    background: url("../assets/img/menu_arrow.png") no-repeat;
    width: 45px;
    height: 11px;
    top: -3px;
    left: 32px;
  }
  .vis .m_arrow{
    display: block;
  }
  header .menu a:hover{
    text-shadow: 2px 2px 2px rgba(200, 200, 200, 1);
  }
</style>
